import React from 'react';
import { NavLink } from 'react-router-dom';
import { APP_LOGO_URL, getSidebarBrandTitle } from '../constants/branding';

/**
 * Brand block for sidebar header or top navbar.
 */
export default function SidebarBrand({
  to = '/dashboard',
  onNavigate,
  agency = null,
  subtitle = null,
  variant = 'sidebar',
}) {
  const agencyLine = getSidebarBrandTitle(agency);
  const showAgencyName = !subtitle && agencyLine && agencyLine !== 'NextFollowUp';

  if (variant === 'topbar') {
    return (
      <NavLink
        className="nf-topbar-brand"
        to={to}
        onClick={onNavigate}
      >
        <img
          src={APP_LOGO_URL}
          alt="NextFollowUp"
          className="nf-topbar-brand-logo"
        />
        <span className="nf-topbar-brand-name">NextFollowUp</span>
      </NavLink>
    );
  }

  return (
    <NavLink
      className="navbar-brand nf-sidebar-brand"
      to={to}
      onClick={onNavigate}
    >
      <img
        src={APP_LOGO_URL}
        alt="NextFollowUp"
        className="nf-sidebar-brand-logo"
      />
      <div className="nf-sidebar-brand-text">
        {showAgencyName ? (
          <span className="nf-sidebar-brand-name" title={agencyLine}>
            {agencyLine}
          </span>
        ) : (
          <span className="nf-sidebar-brand-name">NextFollowUp</span>
        )}
        {subtitle ? (
          <span className="nf-sidebar-brand-sub">{subtitle}</span>
        ) : (
          <span className="nf-sidebar-brand-sub">CRM Workspace</span>
        )}
      </div>
      <i className="fas fa-chevron-down nf-sidebar-brand-chevron" aria-hidden="true" />
    </NavLink>
  );
}
